<!--  -->
<template>
  <div class="History">
    <h1>{{ title }}</h1>
    <div class="History-wire">
      <div class="year-box">
        <ul>
          <li
            :class="{ active: key === onSelect }"
            v-for="(item, key) in Year"
            :key="key"
            @click="
              onPitch(key, item.id);
              changePitch();
            "
          >
            <span>{{ item.year }}</span>
            <div v-show="key != onSelect"></div>
          </li>
        </ul>
      </div>
    </div>
    <transition-group name="fade" mode="in-out">
      <div class="History-main" v-if="show" :key="1">
        <div class="History-photo">
          <img :src="src" />
        </div>
        <div class="History-text">
          <el-timeline>
            <el-timeline-item
              v-for="item in HistoryList"
              :key="item.id"
              :timestamp="item.time"
              placement="top"
            >
              <span v-html="item.msg"></span>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      title: "", //堃博发展历程
      Year: [
        /* 
        {
          year: "2021",
        },
        {
          year: "2020",
        },
        {
          year: "2019",
        },
        {
          year: "2018",
        },
        {
          year: "2017",
        },
       */
      ],
      HistoryList: [
        /* 
        {
          id: "1",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
        {
          id: "2",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
        {
          id: "3",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
        {
          id: "4",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
        {
          id: "5",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
        {
          id: "6",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
        {
          id: "7",
          time: "2020.12.15",
          msg: "德诺收购Broncus，获取肺部精准定位技术",
        },
       */
      ],
      onSelect: 0,
      show: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onPitch(index, id) {
      this.onSelect = index;
      this.show = !this.show;
      this.get_detail(id);
      console.log(123);
    },
    changePitch() {
      var that = this;
      setTimeout(function () {
        that.show = !that.show;
      }, 200);
    },
    //1.文章列表
    get_data() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "article_list",
          category_id: 9,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.title = obj.yj_name;
            $.each(obj.data, function (i, k) {
              that.Year.push({
                id: k.id,
                year: k.title,
              });
            });
            if (obj.data[0].id) that.get_detail(obj.data[0].id);
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
    //2.文章详情
    get_detail(id) {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_article",
          article_id: id,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            if (obj.data.msgs) {
              that.src = obj.data.pic_f;
              that.HistoryList = [];
              var msgs = obj.data.msgs.split("<br />");
              var arrs = [];
              $.each(msgs, function (i, k) {
                arrs = k.split("@");
                that.HistoryList.push({
                  id: i,
                  time: arrs[0],
                  msg: arrs[1],
                });
              });
            }
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.get_data();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.History {
  width: 100%;
  height: 738px;
  background: url("../../assets/aboutHistoryBg.png");
  background-size: cover;
  color: $text-color;
  padding: 40px 0;
  h1 {
    font-size: 1.4rem;
    text-align: center;
  }
  .History-wire {
    margin-top: 50px;
    width: 100%;
    height: 1px;
    background: #e6e6e6;
    .year-box {
      width: $main-width;
      margin: 0 auto;
      position: relative;
      ul {
        width: $main-width;
        margin: 0 auto;
        position: absolute;
        top: -38px;
        display: flex;
        justify-content: flex-end;
        li {
          text-align: center;
          margin: 0 55px;
          cursor: pointer;
          span {
            font-size: 0.9rem;
            display: inline-block;
            margin-bottom: 10px;
          }
          div {
            width: 9px;
            height: 9px;
            background: #e6e6e6;
            border-radius: 50%;
            margin: 0 auto;
          }
        }
        .active {
          width: 93px;
          height: 42px;
          background: #ffc85a;
          border-radius: 50%;
          position: relative;
          top: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            display: inline-block;
            width: 93px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave {
    opacity: 1;
  }
  .fade-enter-active {
    transition: opacity 0.5s;
  }
  .fade-leave-active {
    opacity: 0;
    transition: opacity 0.5s;
  }
  .History-main {
    width: $main-width;
    margin: 70px auto 0;
    display: flex;
    justify-content: space-between;
    .History-photo {
      width: 540px;
      height: 458px;
      img {
        width: 100%;
      }
    }
    .History-text {
      width: 630px;
      height: 458px;
      overflow-y: auto;
      padding-left: 5px;
    }
    .History-text::-webkit-scrollbar {
      width: 4px;
      /*height: 4px;*/
    }
    .History-text::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #f8ad17;
    }
    .History-text::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: #e6e6e6;
    }
    .History-text >>> .el-timeline-item {
      min-height: 90px;
    }
    .History-text >>> .el-timeline-item__timestamp {
      color: $text-color;
      font-size: 1rem;
      line-height: 1.5;
    }
    .History-text >>> .el-timeline-item__content span {
      color: $text-color;
      font-size: 1rem;
      line-height: 1.5;
    }
  }
}
@media screen and (max-width: 1500px) {
  .History {
    .History-wire {
      .year-box {
        ul {
          top: -30px;
          .active {
            top: 8px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: $main-width) {
  .History {
    display: none;
    .History-wire {
      .year-box {
        ul {
          top: -30px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/about/AboutHistory.vue